import { render, staticRenderFns } from "./EventPopUp.vue?vue&type=template&id=38857eae&scoped=true&"
import script from "./EventPopUp.vue?vue&type=script&lang=js&"
export * from "./EventPopUp.vue?vue&type=script&lang=js&"
import style0 from "./EventPopUp.vue?vue&type=style&index=0&id=38857eae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38857eae",
  null
  
)

export default component.exports